import { call, put, all } from "redux-saga/effects";

import {
  fetchAmigoPaguitosLoanDetailsError,
  fetchAmigoPaguitosLoanDetailsSuccess,
} from "../actions/aploan";

import useStorage from "../../hooks/secureStorage";

const getDate = (dateString) => {
  const date = dateString.split("-");
  if (date.length === 3) {
    const formatted = date[2] + "/" + date[1] + "/" + date[0];
    return formatted;
  }
  return dateString;
};

const getDateExpiration = (cuotas) => {
  const array = cuotas.filter((cuota) => cuota.estado === "PEND");
  if (array.length) {
    return getDate(array[0].fecha_vencimiento);
  }
  const mora = cuotas.filter((cuota) => cuota.estado === "MORA");
  if (mora.length) {
    return getDate(mora[0].fecha_vencimiento);
  }
  return "";
};

const getPendingAmount = (cuotas) => {
  return cuotas
    .filter((cuota) => ["PEND", "MORA"].includes(cuota.estado))
    .reduce(
      (total, cuota) => total + (parseFloat(cuota.total_a_pagar) || 0),
      0
    );
};

const getNextPay = (cuotas) => {
  const pend = cuotas.filter((cuota) => cuota.estado === "PEND");
  const pendiente = pend.filter((cuota) => {
    const year = cuota.fecha_vencimiento.substring(0, 4);
    const month = cuota.fecha_vencimiento.substring(5, 7);
    const day = cuota.fecha_vencimiento.substring(8, 10);
    const date = new Date(year, Number(month) - 1, day);
    let end = new Date();
    end.setUTCHours(23, 59, 59, 999);
    return date.getTime() > end.getTime();
  });
  return pendiente && pendiente.length ? pendiente[0].total_a_pagar : 0; // + mora
};

function* fetchAmigoPaguitosToken() {
  let APToken;
  const APTokenStored = useStorage.getSecureLS("AP_TOKEN");
  const APTokenExpStored = useStorage.getSecureLS("AP_TOKEN_EXP");

  if (!APTokenStored || APTokenExpStored < Date.now() / 1000) {
    const user = process.env.REACT_APP_AMIGO_PAGUITOS_USER;
    const password = process.env.REACT_APP_AMIGO_PAGUITOS_PASSWORD;
    try {
      const request = yield call(
        fetch,
        `${process.env.REACT_APP_URL_AMIGO_PAGUITOS}/auth`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user,
            password,
          }),
          redirect: "follow",
        }
      );
      const result = yield request.json();
      const { data = {} } = result;
      if (data.token) {
        APToken = data.token;
        useStorage.setSecureLS("AP_TOKEN", data.token);
        useStorage.setSecureLS("AP_TOKEN_EXP", data.expire);
      }
    } catch (error) {
      console.error("Error fetching", error);
      throw error;
    }
  } else {
    APToken = APTokenStored;
  }

  return APToken;
}

export function* fetchAmigoPaguitosLoan({ loanId }) {
  let result;
  let cuotasResult;
  try {
    const token = yield fetchAmigoPaguitosToken();
    if (!token) throw new Error("No token available");
    const [request, cuotasRequest] = yield all([
      yield call(
        fetch,
        `${process.env.REACT_APP_URL_AMIGO_PAGUITOS}/prestamo/${loanId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      ),
      yield call(
        fetch,
        `${process.env.REACT_APP_URL_AMIGO_PAGUITOS}/prestamo/${loanId}/cuotas`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      ),
    ]);
    result = yield request.json();
    cuotasResult = yield cuotasRequest.json();
    if (
      (request && request.status && request.status < 200) ||
      request.status >= 300
    ) {
      throw new Error(request.statusText || "Unknown error");
    }
    if (
      (cuotasRequest && cuotasRequest.status && cuotasRequest.status < 200) ||
      cuotasRequest.status >= 300
    ) {
      throw new Error(cuotasRequest.statusText || "Unknown error");
    }
    const status = (result && result.data && result.data.estado) || undefined;
    const expirationDate = getDateExpiration(
      (cuotasResult && cuotasResult.data) || []
    );
    const pendingAmount = getPendingAmount(cuotasResult.data);
    const maxAmount = getNextPay(cuotasResult.data);

    yield put(
      fetchAmigoPaguitosLoanDetailsSuccess({
        status,
        data: result.data,
        cuotas: cuotasResult,
        detail:
          (result.data &&
            result.data.productos &&
            result.data.productos.length > 0 &&
            result.data.productos[0] &&
            result.data.productos[0].nombre) ||
          "",
        dueDate: (result.data && result.data.fecha_vencimiento) || "",
        expirationDate,
        maxAmount,
        reference: loanId,
        periodicity: result.data && result.data.periodicidad,
        pendingAmount,
        model:
          (result.data &&
            result.data.productos &&
            result.data.productos.length > 0 &&
            result.data.productos[0] &&
            result.data.productos[0].nombre_modelo) ||
          "",
        brand:
          (result.data &&
            result.data.productos &&
            result.data.productos.length > 0 &&
            result.data.productos[0] &&
            result.data.productos[0].nombre_marca) ||
          "",
      })
    );
  } catch (error) {
    console.error("error throw", error, "result", result);
    yield put(
      fetchAmigoPaguitosLoanDetailsError(error, {
        ...result,
      })
    );
  }
}
